export default __webpack_public_path__ + "resources/icons/d220-3ed7.png";